import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Text } from '@wix/design-system';
import { CollectionActionCustomLayoutModal } from '../CollectionActionModal';
import { CustomFieldForm } from '.';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { CustomFieldModalPrimaryButton } from './CustomFieldModalPrimaryButton';
import { CustomFieldModalState, DataExtensionState } from '@wix/bex-core';
import { minimalRequiredWdsRuntimeCheck } from '../../minimalRequiredWdsRuntimeCheck';

export const _CustomFieldModal = ({ state }: { state: DataExtensionState }) => {
  if (process.env.NODE_ENV !== 'production') {
    // We show form errors in the FormField status messages which were introduced
    // in wix-style-react 10.56.0
    minimalRequiredWdsRuntimeCheck({
      required: '^1.64.1',
      requiredBy: 'Cairo/CustomFieldModal',
    });
  }

  const {
    translate: t,
    environment: { language },
  } = useWixPatternsContainer();

  const [customFieldModalState] = useState(() => {
    state.customFieldModalState ??= new CustomFieldModalState({
      dataExtensionState: state,
    });

    return state.customFieldModalState!;
  });

  const {
    mode,
    customFieldModalBiReporter: { reportLearnMoreClick, reportModalEndProcess },
  } = customFieldModalState;

  return (
    <CollectionActionCustomLayoutModal
      dataHook="custom-field-modal"
      state={customFieldModalState.modalState}
      title={
        mode === 'new'
          ? t('cairo.customFields.addCustomField.modal.title')
          : t('cairo.customFields.editCustomField.modal.title')
      }
      subtitle={
        mode === 'new' && (
          <Box direction="vertical">
            <Text>{t('cairo.customFields.addCustomField.modal.subtitle')}</Text>
            <Text>
              {t('cairo.customFields.addCustomField.modal.subtitle.note')}
            </Text>
          </Box>
        )
      }
      content={<CustomFieldForm state={customFieldModalState} />}
      primaryButtonText={
        <CustomFieldModalPrimaryButton
          state={customFieldModalState}
          content={
            mode === 'new'
              ? t('cairo.customFields.addCustomField.modal.add.CTA')
              : t('cairo.customFields.editCustomField.save.CTA')
          }
        />
      }
      secondaryButtonText={t(
        'cairo.customFields.addCustomField.modal.cancel.CTA',
      )}
      onCloseButtonClick={() => {
        reportModalEndProcess({ endType: 'Cancel' });
      }}
      secondaryButtonOnClick={() => {
        reportModalEndProcess({ endType: 'Cancel' });
      }}
      footnote={
        <Text size="small">
          {t('cairo.customFields.addCustomField.modal.PII')}
          &nbsp;
          <a
            href={`https://support.wix.com/${language}/article/about-personally-identifiable-information-pii`}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              reportLearnMoreClick();
            }}
          >
            {t('cairo.customFields.addCustomField.modal.PII.learnMore')}
          </a>
        </Text>
      }
    />
  );
};

export const CustomFieldModal = observer(_CustomFieldModal);
